import { h } from 'preact';
import { OrdersListItem } from './OrdersListItem';
import type { Order } from '../shopware/shopwareApi';

interface OrdersListProps {
  orders: Order[];
  expandedOrder: string | null;
  onToggleDetails: (orderNumber: string) => void;
}

export const OrdersList = ({ orders, expandedOrder, onToggleDetails }: OrdersListProps) => {
  if (!orders || orders.length === 0) {
    return (
      <div className="text-center py-7">
        <p className="m-0">Mit den aktuellen Filtern wurden keine Bestellungen gefunden.</p>
      </div>
    );
  }

  return (
    <div className="pt-4 pt-md-5">
      <div className="mx-md-n4 mx-lg-0 orders-table-holder">
        <table className="orders-table w-100 mx-md-4 mx-lg-0">
          <thead>
            <tr>
              <th className="fw-normal text-nowrap ps-md-3 ps-xl-5 pe-md-3 py-3">Bestellnummer</th>
              <th className="text-nowrap p-3">Bestelldatum</th>
              <th className="text-nowrap p-3">Betrag</th>
              <th className="text-nowrap p-3">Versandstatus</th>
              <th className="text-nowrap text-center p-3">Treuepunkte</th>
              <th className="text-nowrap text-center p-3">Rechnung</th>
            </tr>
          </thead>
          <tbody id="orders-table-body">
            {orders.map((order) => (
              <OrdersListItem
                key={order.orderNumber}
                order={order}
                isExpanded={expandedOrder === order.orderNumber}
                onToggleDetails={onToggleDetails}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
